import * as pdfjs from 'pdfjs-dist/legacy/build/pdf.min.js'
import PdfjsWorker from 'worker-loader!pdfjs-dist/legacy/build/pdf.worker.js'

if (typeof window !== 'undefined' && 'Worker' in window) {
  pdfjs.GlobalWorkerOptions.workerPort = new PdfjsWorker();
}
